import Flickity from 'flickity';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


export default {
  init($element) {
  },
  finalize($element) {
    if ($element.find('.other-walks-mob-carousel')) {
      const walksCarousel = new Flickity($element.find('.other-walks-mob-carousel').get()[0], {
        // adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
          },
        },
      });

      // Set the width of the scroller based on the number of carousel items
      const carouselItems = $element.find('.other-walks-mob-carousel .carousel-cell').length;
      const carouselPercentage = (1 / carouselItems) * 100;
      $element.find('.progress-slider-wrap .progress-slider-inner').css({ width: carouselPercentage.toString() + '%' });

      // Set the scroller position
      walksCarousel.on('change', function(i) {
        var currentIndex = i;

        if ($(window).outerWidth() >= 992) {
          // First pressing the next button does not move the slider because apparently 0 == 1 :)
          if (currentIndex == 1) {
            currentIndex = 0;
          }

          // Snap to prevent weird thing where continuously scrolling right at the end
          // of the carousel causes the scroller to switch between carouselItems and carouselItems - 1
          if (currentIndex == carouselItems - 2) {
            currentIndex = carouselItems - 1;
          }
        }

        const scrollPosition = carouselPercentage * currentIndex;
        $element.find('.progress-slider-wrap .progress-slider-inner').css({ left: scrollPosition.toString() + '%' });
      });

      // Scroll buttons
      $element.find('.progress-slide-arrow-prev').on('click', function() {
        walksCarousel.previous();

        if ($(window).outerWidth() >= 992) {
          // Again another funny workaround
          if (walksCarousel.selectedIndex == carouselItems - 2) {
            walksCarousel.previous();
          }
        }
      });
      
      $element.find('.progress-slide-arrow-next').on('click', function(i) {
        walksCarousel.next();

        if ($(window).outerWidth() >= 992) {
          // Again another funny workaround
          if (walksCarousel.selectedIndex == 1) {
            walksCarousel.next();
          }
        }
      });

      walksCarousel.on('change', function(i) {
        if (i == 0) {
          $element.find('.progress-slide-arrow-prev').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-prev').removeClass('disabled');
        }

        if (i + 1 >= walksCarousel.slides.length) {
          $element.find('.progress-slide-arrow-next').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-next').removeClass('disabled');
        }
      });
    }

    if ($element.find('.shared-walks-of-the-month')) {
      
      //Featured Image animation on scroll
      const featuredWalk = $element.find('.featured-walk-image').get();

      gsap.fromTo(featuredWalk, {
        scaleX: 1.1,
        scaleY: 1.1,
        }, {
        scrollTrigger: {
        trigger: featuredWalk,
        start: 'top center',
        end: 'top top',
        scrub: 1,
        },
        scaleX: 1,
        scaleY: 1,
      });

      // const otherWalks = document.querySelectorAll('.other-walk-row .other-walk-col');
      const otherWalks = $element.find('.other-walk-row .other-walk-col');

      gsap.fromTo(otherWalks, {
        y: 30,
        autoAlpha: 0, 
        }, {
        scrollTrigger: {
        trigger: otherWalks,
        start: 'top bottom',
        },
        y: 0,
        autoAlpha: 1, 
        stagger: 0.2,
        duration: .6,
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/walksOfTheMonth.js